import React, { useEffect, useState, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import { message, Input, Drawer, Space, Modal, Button as Buttons, Spin } from 'antd'; // Popover, Checkbox 
import 'react-tagsinput/react-tagsinput.css';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import { PDFViewer } from '@react-pdf/renderer';
import { ExclamationCircleOutlined } from '@ant-design/icons'
import propTypes from 'prop-types';
import { MailBox2 } from './email-style';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import { ExchangeCurrency } from '../Filters/FilterConditions';
import { FetchAllAttendeeList, FecthModuleEncryptedToken, getExchangeRate } from '../../../Api/Services/CommonApiService'
import { FetchAllRecentMails1, sendTemplateMail } from '../../../Api/Services/EmailApiSevices';
import { Button } from '../../../components/buttons/buttons';
import TinyMCEEditor from "../EditorFolder/TinyMCE"
import QuotationPdf from '../QISC/PdfComponents/QuotationPdf';
import SalesPdf from '../QISC/PdfComponents/SalesOrderPdf';
import InvoicePdf from '../QISC/PdfComponents/InvoicePdf';
// import { LinkEmailIcon } from '../../../components/Icons/Icons';

function Compose({ close, mailOpen, entity, entityName, toId, AllData, invoiceToken, MailContent, SubjectData, attachFile, updateStatus, updateId, setNaCTrigger }) {
    const WebUrl = process.env.REACT_APP_BASE_URL_WEB
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyDetals = localData.company
    const [popupMessage, setPopupMessage] = useState(false)
    const [state, setState] = useState({
        size: 'big',
        tags: [],
    });
    const [disabled, setDisbled] = useState(false)
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [composeSize, setComposeSize] = useState(entityName === "cases" ? 600 : 1400)
    const [linkType, setLinkType] = useState('Contacts_Leads,Accounts');
    const [subject, setSubject] = useState("")
    const [content, setContent] = useState("");
    const [files, setFiles] = useState([]);
    const [companyToken, setCompanyToken] = useState()
    const [stripeToken, setStripeToken] = useState()
    const [amountToken, setAmountToken] = useState()
    const [paymentLinkAdded, setPaymentLinkAdded] = useState(false)
    const toggleSize = (value) => {
        setComposeSize(value)
    }
    const onEmailSend = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        const formattedHtmlContent = `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html><head><meta content="text/html;charset=UTF-8" http-equiv="Content-Type"><link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"rel="stylesheet"></head><body><div>${content}</div></body></html>`;
        setDisbled(true)
        const payload = {
            to: state.tags,
            content: formattedHtmlContent,
            subject,
            attachments: files,
        }
        let hideMessage;
        try {
            hideMessage = message.loading("Sending Email", 0);
            const response = await sendTemplateMail(linkType, payload)
            if (response.status === 201) {
                setTimeout(() => {
                    FetchAllRecentMails1("Sent")
                        .then(() => {
                            if (entityName === "cases") {
                                setNaCTrigger("CallBack")
                            }
                        })
                        .catch(err => {
                            if (entityName === "cases") {
                                setNaCTrigger("CallBack")
                            }
                            console.error("Error fetching recent mails:", err);
                        });
                }, 2000);
                hideMessage();
                setDisbled(false)
                close()
                setState({
                    size: 'big',
                    tags: [],
                });
                setLinkType("Contacts_Leads,Accounts")
                setSubject("")
                setContent("");
                message.success("Email sent")
                if (entityName !== "cases") {
                    updateStatus(updateId)
                }
                loadingRef.current = false;
                setDoubleClick(false)
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            setDisbled(false)
            message.error(error);
        }
    }
    const ComposeClose = () => {
        toggleSize(entityName === "cases" ? 600 : 1400)
        setPopupMessage(false)
        setDisbled(false)
        close()
        setState({
            size: 'big',
            tags: [],
        });
        setLinkType("Contacts_Leads,Accounts")
        setSubject("")
        setContent("");
    }
    const handleClose = () => {
        setPopupMessage(true)
    }
    const onCancel = () => {
        setPopupMessage(false)
    }
    async function getCompanyEncryption() {
        try {
            const response = await FecthModuleEncryptedToken(profile.companyId, profile.companyId)
            setCompanyToken(response.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getStripeToken() {
        if (companyDetals.stripeAccountId) {
            try {
                const response = await FecthModuleEncryptedToken(companyDetals.stripeAccountId, profile.companyId)
                setStripeToken(response.data)
            } catch (error) {
                message.error(error)
            }
        }
    }
    async function getAmountEncryption() {
        try {
            const exchangeRate = await getExchangeRate(AllData?.currencySettings?.currency, "USD")
            const amount = await ExchangeCurrency(Number(
                AllData?.Calculation?.grandTotal), Number(exchangeRate.data))
            const response = await FecthModuleEncryptedToken(Number(amount), profile.companyId)
            setAmountToken(response.data)
        } catch (error) {
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            getCompanyEncryption(),
            getAmountEncryption(),
            getStripeToken(),
        ])
    };
    useEffect(() => {
        if (mailOpen) {
            if (entityName === "cases") {
                setSubject(SubjectData)
                setContent(MailContent)
            }
            if (entityName !== "cases" && MailContent && SubjectData && attachFile) {
                setSubject(SubjectData)
                setContent(MailContent)
                setFiles([attachFile])
            }
            if (entityName === "invoice") {
                fetchAll()
            }
        }
    }, [MailContent, SubjectData, attachFile, mailOpen])
    const edit = true;
    const [participantData, setParticipantData] = useState([])
    const [toSelectedItems, setToSelectedItems] = useState([]);

    // const [openQuery, setOpenQuery] = useState(false);
    const Emailsarray = (emailString) => {
        const newUserList = emailString.map(replayids => {
            let userData = participantData.find(item => item.email === replayids);
            if (!userData) {
                userData = {
                    id: "",
                    name: replayids,
                    type: "Others",
                    email: replayids,
                };
            }
            else {
                userData = {
                    id: userData.id,
                    name: userData.name,
                    type: userData.type,
                    email: userData.email,
                };
            }
            return userData;
        });
        return newUserList;
    };
    async function getPartcipants() {
        try {
            const data = await FetchAllAttendeeList()
            setParticipantData(data)
        }
        catch (error) {
            message.error(error)
        }
    };
    // const handleOpenQureyChange = (newOpen) => {
    //     setOpenQuery(newOpen);
    // };
    // const handleCheckboxChange = (field, isChecked) => {
    //     let updatedFields = linkType.split(',').filter(Boolean);
    //     if (isChecked) {
    //         updatedFields.push(field);
    //     } else {
    //         updatedFields = updatedFields.filter(item => item !== field);
    //     }
    //     setLinkType(updatedFields.join(','));
    // };
    // const Action = (
    //     <div style={{
    //         padding: "0px 20px 0px 20px",
    //         width: "100%",
    //         height: "100%",
    //     }}>
    //         <div>
    //             <Checkbox
    //                 checked
    //                 disabled
    //             >
    //                 Link this email to <b>Contacts/Leads</b> in the &quot;To&quot; field
    //             </Checkbox>
    //         </div>
    //         <div >
    //             <Checkbox
    //                 checked={linkType.includes('Accounts')}
    //                 onChange={(e) => handleCheckboxChange('Accounts', e.target.checked)}
    //             > Link this email to <b>Accounts</b> related to contacts in the &quot;To&quot; field
    //             </Checkbox>
    //         </div>
    //         <div >
    //             <Checkbox
    //                 checked={linkType.includes('Deals')}
    //                 onChange={(e) => handleCheckboxChange('Deals', e.target.checked)}
    //             > Link this email to <b>Deals</b> related to contacts in the &quot;To&quot; field
    //             </Checkbox>
    //         </div>
    //     </div>
    // )
    const downloadAttachment = (attachment) => {
        const blob = new Blob([new Uint8Array(attachment.content.data)], { type: attachment.contentType });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = attachment.filename;
        link.click();
        URL.revokeObjectURL(link.href);
    };
    const removeRow = async (index) => {
        const updatedFormData = [...files];
        updatedFormData.splice(index, 1);
        setFiles(updatedFormData);
    }
    const shortenFilename = (filename, maxLength = 20) => {
        const extension = filename.substring(filename.lastIndexOf('.'));
        const nameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'));
        if (nameWithoutExtension.length > maxLength) {
            return `${nameWithoutExtension.substring(0, maxLength)}...${extension}`;
        }
        return filename;
    };
    useEffect(() => {
        if (mailOpen) {
            if (entityName) {
                getPartcipants()
            }
        }
    }, [entityName, entity, mailOpen])
    useEffect(() => {
        if (mailOpen) {
            if (participantData.length > 0 && toId) {
                const processedUsers = Emailsarray(toId);
                setState({ ...state, tags: processedUsers });
                setToSelectedItems(processedUsers)
            }
        }
    }, [participantData, toId, mailOpen])
    // cases
    const showConfirm = () => {
        const hasSubject = subject !== undefined && subject !== null && subject !== "";
        const hasRecipients = Array.isArray(toSelectedItems) && toSelectedItems.length > 0;
        let title;
        let content;
        let okText;
        let cancelText;
        let showCancel;
        let onOkHandler;
        let onCancelHandler;
        if (!hasRecipients) {
            // Case 2: No recipients
            title = (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>No Recipients</span>
                </div>
            );
            content = <p>Please add at least one recipient before sending this message.</p>;
            okText = "OK";
            cancelText = null;
            showCancel = false;
            onOkHandler = (modalInstance) => modalInstance.destroy();
            onCancelHandler = null;
        }
        else if (!hasSubject) {
            // Case 1: Missing subject
            title = (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Missing subject</span>
                </div>
            );
            content = <p>Do you want to send this message without a subject?</p>;
            okText = "Don't send";
            cancelText = "Send";
            showCancel = true;
            onOkHandler = (modalInstance) => modalInstance.destroy();
            onCancelHandler = () => onEmailSend();
        }
        else {
            // Default case (safe fallback)
            return onEmailSend();
        }
        const modalInstance = Modal.confirm({
            title,
            icon: null,
            className: "customice-confirm-modal",
            content,
            centered: true,
            okText,
            cancelText,
            okButtonProps: { className: "gray-buttonModal" },
            cancelButtonProps: { className: "button_colorsModal" },
            okCancel: showCancel,
            onOk: () => onOkHandler(modalInstance),
            onCancel: onCancelHandler,
        });
    };
    const SubjectNameCheck = () => {
        if (subject !== undefined && subject !== null && subject !== "") {
            onEmailSend()
        } else {
            showConfirm()
        }
    }
    const handleAddSignature = () => {
        setContent((prevContent) => {
            const identifier = "signature-block-unique";

            const signatureHtml = `<div id="${identifier}">
      ${profile?.profileSignature || "<div>Add signature</div>"}
    </div>`;
            const spacerDivs = `<div>&nbsp;</div><div>&nbsp;</div>`;
            // Check if signature already exists
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = prevContent;
            const existingSignature = tempDiv.querySelector(`#${identifier}`);

            if (existingSignature) {
                // Replace existing signature
                existingSignature.outerHTML = signatureHtml;
                return tempDiv.innerHTML;
            }
            const replyBlock = tempDiv.querySelector("#ReplyContent");
            if (replyBlock) {
                // Determine target block to insert before
                const targetBlock = replyBlock;

                // Insert signature before the reply/forward section
                const wrapper = document.createElement('div');
                wrapper.innerHTML = `${spacerDivs}${signatureHtml}`;
                targetBlock.parentNode.insertBefore(wrapper, targetBlock);

                return tempDiv.innerHTML;
            }

            const contentToAdd = prevContent.trim() === ""
                ? prevContent.trim() + spacerDivs
                : prevContent.trim();
            // Add new signature
            return `${contentToAdd.trim()}${signatureHtml}`;
        });
    };
    const handleAddInviceLink = () => {
        setContent((prevContent) => {
            const identifier = "payment-link-block";
            const paymentUrl = `${WebUrl}?type=INV&&PA=${amountToken}&&CTID=${companyToken}&&INID=${invoiceToken}&&CUE=${AllData?.data?.billingAddress?.email}&&STID=${stripeToken}`

            // Create the payment link HTML
            const paymentLinkHtml = `<div id="${identifier}" style="margin-top: 10px;">
      <a href="${paymentUrl}" target="_blank" style="color: #1890ff; text-decoration: underline;">
        Click here to pay your invoice
      </a>
    </div>`;

            // Parse the current content
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = prevContent;

            // Check if payment link already exists
            const existingLink = tempDiv.querySelector(`#${identifier}`);

            if (existingLink) {
                // Remove it if it exists
                existingLink.remove();
                setPaymentLinkAdded(false);
                message.success('Payment link removed successfully');
                return tempDiv.innerHTML;
            }

            // ✅ 2. Only check Stripe when INSERTING
            const isStripeReady = companyDetals?.stripeReady;
            if (!isStripeReady) {
                message.warning(
                    "Please set up a payment platform in the Product Integrations page before adding a payment link"
                );
                return prevContent; // important: don't modify content
            }
            // Try to insert after "Total Amount" div
            const invoiceDivs = Array.from(tempDiv.querySelectorAll("div"));
            const totalAmountDiv = invoiceDivs.find(div =>
                div.textContent.includes("Total Amount")
            );

            if (totalAmountDiv) {
                const wrapper = document.createElement("div");
                wrapper.innerHTML = paymentLinkHtml;
                totalAmountDiv.after(wrapper);
            } else {
                // Fallback: append at the end
                tempDiv.appendChild(document.createRange().createContextualFragment(paymentLinkHtml));
            }

            setPaymentLinkAdded(true);
            message.success('Payment link added successfully');
            return tempDiv.innerHTML;
        });
    };
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                width={composeSize}
                open={mailOpen}
                title="Email"
                extra={
                    < Space >
                        <div style={{ display: entityName === "cases" ? "flex" : "none", alignItems: "center", gap: 20 }}>
                            {composeSize === 600 ?
                                <FeatherIcon onClick={() => toggleSize(1200)} icon="maximize-2" size={20} style={{ cursor: "pointer" }} /> :
                                <FeatherIcon onClick={() => toggleSize(600)} icon="minimize-2" size={20} style={{ cursor: "pointer" }} />}
                            {/* <FeatherIcon onClick={() => handleClose()} icon="x" size={20} style={{ cursor: "pointer" }} /> */}
                        </div>
                    </Space >
                }
                footer={[<div className="form_action_button">
                    <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                        <FeatherIcon icon="x" /> Cancel
                    </Button>
                    <Button size="small" onClick={() => SubjectNameCheck()} raised className="button_colors" disabled={state?.tags?.length === 0 || disabled || doubleClick} loading={doubleClick}>
                        {!doubleClick && <FeatherIcon icon="send" />}Send
                    </Button>
                </div>]}
            >
                <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <div style={{ margin: "20px 40px" }}>
                        <MailBox2>
                            <div className="body email-body" style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ width: entityName === "cases" ? "100%" : "60%" }}>
                                    <div className="body">
                                        <div className="group">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                                                <div className="reply-inner">
                                                    {toSelectedItems.length > 0 && toSelectedItems[0] &&
                                                        <div className='Div_flex'>
                                                            {toSelectedItems?.map((item, index) => (
                                                                <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                                                    <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                                                        : item.type === "User" ? "UserIcon"
                                                                            : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                                                        {item.name?.slice(0, 1).toUpperCase()}
                                                                    </span>
                                                                    <span>{`${item.name.substring(0, 10)}...`}</span>
                                                                    {/* {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => TohandleDeselect(item)} />} */}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }
                                                    {/* <TopToolBoxClone>
                                              <AutoComplete
                                                style={{ width: "100%", maxWidth: "100%" }}
                                                onSearch={TohandleSearch}
                                                onSelect={TohandleSelect}
                                                options={toOptions}
                                                value={toInputValue}
                                                onChange={setToInputValue}
                                              >
                                                <Input placeholder='To' />
                                              </AutoComplete>
                                            </TopToolBoxClone> */}
                                                </div>
                                            </div>
                                            <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                                        </div>
                                        <div className="group">
                                            <Input placeholder="Subject" type="text" value={subject} onChange={(e) => setSubject(e.target.value)} />
                                        </div>
                                        <div className="template" style={{ display: "flex", alignItems: "center", gap: "25px" }}>
                                            <Buttons
                                                type="text"
                                                onClick={handleAddSignature}
                                                className='signature-Button'
                                            >
                                                <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <FeatherIcon icon="plus-circle" className="text_iconspace" size={15} /> Add signature</span>
                                            </Buttons>

                                            {entityName === "invoice" ? <Buttons
                                                type="text"
                                                onClick={handleAddInviceLink}
                                                className='signature-Button'
                                            >
                                                <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <FeatherIcon icon={paymentLinkAdded ? "x-circle" : "plus-circle"} className="text_iconspace" size={15} />
                                                    {paymentLinkAdded ? "Remove payment link" : "Add payment link"}
                                                </span>
                                            </Buttons> : <></>}
                                        </div>
                                        {/*   <div style={{ cursor: "pointer" }}>
                                        <Popover
                                            placement="bottomLeft"
                                            content={Action}
                                            trigger="hover"
                                            open={openQuery}
                                            onOpenChange={handleOpenQureyChange}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <LinkEmailIcon marginRight={5} width={16} height={16} marginBottom={2} /><span className="text_iconspace">Link Email</span><DownOutlined style={{ fontSize: '12px' }} />
                                            </div>
                                        </Popover>
                                    </div>
                                </div> */}
                                        <div className="group">
                                            <TinyMCEEditor placeholder="Compose email..." setContent={setContent} content={content} edit={edit} page="Email" setFiles={setFiles} height={400} selectedEntity="A" />
                                        </div>
                                    </div>
                                </div>
                                {entityName !== "cases" &&
                                    <div style={{ width: "40%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        {AllData?.companyData ? (
                                            <PDFViewer width="100%" height="100%">
                                                {entityName === "quotes" &&
                                                    <QuotationPdf data={AllData?.data} companyData={AllData?.companyData} tableItem={AllData?.tableItem} tableColum={AllData?.tableColum} currencySettings={AllData?.currencySettings} Calculation={AllData?.Calculation} />}
                                                {entityName === "salesOrder" &&
                                                    <SalesPdf data={AllData?.data} companyData={AllData?.companyData} tableItem={AllData?.tableItem} tableColum={AllData?.tableColum} currencySettings={AllData?.currencySettings} Calculation={AllData?.Calculation} />}
                                                {entityName === "invoice" &&
                                                    <InvoicePdf data={AllData?.data} companyData={AllData?.companyData} tableItem={AllData?.tableItem} tableColum={AllData?.tableColum} currencySettings={AllData?.currencySettings} Calculation={AllData?.Calculation} />}
                                            </PDFViewer>
                                        ) : (
                                            <Spin size="small" />
                                        )}
                                    </div>
                                }
                            </div>
                            <div className="group" style={{ marginTop: "20px", display: "flex", gap: 10 }}>
                                {files.map((file, index) => (
                                    <figure key={index} style={{ display: "flex", gap: 10 }}>
                                        <div className="attachment-image">
                                            <img style={{ height: "40px" }}
                                                src={require('../../../static/img/defaultImages/justify.png')}
                                                alt={file.filename}
                                            />
                                        </div>
                                        <figcaption style={{ flex: 1, marginTop: 0 }}>
                                            <div title={file.filename} style={{
                                                cursor: "default",
                                                fontWeight: 700,
                                                fontSize: 12,
                                            }}>{shortenFilename(file.filename, 20)}</div>
                                            <div style={{
                                                display: "flex", alignItems: "center", justifyContent: "flex-start",
                                                gap: '10px',
                                                marginTop: '5px',
                                            }}>
                                                <span style={{
                                                    fontSize: 10,
                                                    fontWeight: 600,
                                                    color: "#4183f1",
                                                    cursor: "pointer",
                                                    flexGrow: 0,
                                                }} role="button" tabIndex={0}
                                                    onClick={() => downloadAttachment(file)}
                                                    onKeyDown={(event) => {
                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                            downloadAttachment(file)
                                                        }
                                                    }}> Download
                                                </span>
                                                <span style={{
                                                    fontSize: 10,
                                                    fontWeight: 600,
                                                    color: "red",
                                                    cursor: "pointer",
                                                    flexGrow: 0,
                                                }}>
                                                    <FeatherIcon icon="trash-2" size={10} style={{ marginTop: 2 }} onClick={() => removeRow(index)} />
                                                </span>
                                            </div>
                                        </figcaption>
                                    </figure>
                                ))}
                            </div>
                        </MailBox2>
                    </div>
                </Scrollbars>
            </Drawer>
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType="QSI" close={ComposeClose} onclose={onCancel} />}
        </>
    );
}

Compose.propTypes = {
    close: propTypes.func,
    entity: propTypes.string,
    entityName: propTypes.string,
    toId: propTypes.string,
    MailContent: propTypes.string,
    SubjectData: propTypes.string,
    AllData: propTypes.object,
    attachFile: propTypes.object,
    updateStatus: propTypes.func,
    updateId: propTypes.number,
    mailOpen: propTypes.bool,
    setNaCTrigger: propTypes.func,
    invoiceToken: propTypes.string,
};

Compose.defaultProps = {
    close: () => { },
};

export default Compose;
